import i18n from '@/locales/i18n'
import { computed } from 'vue'

export enum EKeyCategory {
    FILTER_1 = 'filter1',
    FILTER_2 = 'filter2'
}

export const EKeyCategoryValues = [EKeyCategory.FILTER_1, EKeyCategory.FILTER_2]

export const EKeyCategoryLabels = computed(() => ({
    [EKeyCategory.FILTER_1]: i18n.global.t('enum.keyCategory.filter1'),
    [EKeyCategory.FILTER_2]: i18n.global.t('enum.keyCategory.filter2')
}))
